import type { PartnerAllocationPnL, PartnerPnLSummary } from '../models/PartnerPortalTypes';

/** Normalize Indian mobile to 10 digits for lookup. */
export function normalizePartnerPhone(input: string): string {
  const digits = input.replace(/\D/g, '');
  if (digits.length >= 10) {
    return digits.slice(-10);
  }
  return digits;
}

export function formatPartnerPhoneDisplay(phone: string): string {
  const n = normalizePartnerPhone(phone);
  if (n.length === 10) {
    return `+91 ${n.slice(0, 5)} ${n.slice(5)}`;
  }
  return phone;
}

export function sumAllocationPnL(items: { pnl: PartnerAllocationPnL }[]): PartnerPnLSummary {
  return items.reduce(
    (acc, { pnl }) => ({
      realizedProfit: acc.realizedProfit + pnl.realizedProfit,
      realizedLoss: acc.realizedLoss + pnl.realizedLoss,
      unrealizedProfit: acc.unrealizedProfit + pnl.unrealizedProfit,
      unrealizedLoss: acc.unrealizedLoss + pnl.unrealizedLoss,
    }),
    { realizedProfit: 0, realizedLoss: 0, unrealizedProfit: 0, unrealizedLoss: 0 }
  );
}

export function netPnL(summary: PartnerPnLSummary): number {
  return (
    summary.realizedProfit -
    summary.realizedLoss +
    summary.unrealizedProfit -
    summary.unrealizedLoss
  );
}

export function netAllocationPnL(pnl: PartnerAllocationPnL): number {
  return pnl.realizedProfit - pnl.realizedLoss + pnl.unrealizedProfit - pnl.unrealizedLoss;
}

export function emptyAllocationPnL(): PartnerAllocationPnL {
  return { realizedProfit: 0, realizedLoss: 0, unrealizedProfit: 0, unrealizedLoss: 0 };
}
